import React from "react";

export const Bhs = (props) => {
  return (
    <div id="bhs" className="text-center">
      <div className="container">
      {/* bhs-2 */}
        <div className="row bhs-2">
          <div>
            <h2>Our Products</h2>
          </div>
          <div className="col-md-6">
            <img src="../img/bhs/01.jpg" alt="..." className="bhs-img" />
          </div>
          <div className="bhs-text col-md-6 bhs-text">
            <h3>Baggage Handling System (BHS) Integration with Baggage X-Ray for Airports</h3>
            <p>The integration of Baggage Handling Systems (BHS) with X-ray screening technology in airports creates a seamless, automated, and secure process for managing checked luggage. This integrated approach streamlines operations from check-in to aircraft loading while ensuring compliance with international security standards.</p>
          </div>
        </div>

        {/* bhs-1 */}
        <div className="row bhs-1">
          <div className="col-xs-12 col-md-6 bhs-text">
            <h3>Body Screening Systems for Passengers</h3>
            <p>
              Body Screening Systems are advanced airport security solutions designed to screen passengers quickly and safely before boarding. Using millimeter-wave technology, the system detects concealed weapons, explosives, or prohibited items hidden under clothing without physical contact. It provides fast, accurate, and non-intrusive screening while protecting passenger privacy and improving overall security checkpoint efficiency.            </p>
          </div>
          <div className="col-xs-12 col-md-6">
            <img src="../img/bhs/02.jpg" alt="..." className="bhs-img" />
          </div>
        </div>

        {/* bhs-3 */}
        {/* <div className="row bhs-3">
          <div className="col-md-12">
            <img src="../img/bhs/03.jpg" alt="..." className="bhs-img" />
          </div>
        </div> */}
      </div>

    </div>
  );
};
